/*
    Método para calcular, mensalidade do associado, caso seja ZPA, ZP4, ZPCA ou ZPC4

    associado: Obj,
    totalDep: Number
 */

export default function calculateValorTotal(associado, totalDep, valoresAdicionais) {
    let somaValores;
    let valorTotal; //Variavel que retorna o valor final da mensalidade
    let totalDeMensalidades;
    let valorTotalSomaDependente;
    const valorDesconto = 0.9;

    if (associado && associado.SubGrupo) {
        switch (associado.SubGrupo.trim()) {
        case 'ZP4':
            totalDeMensalidades = 48;
            somaValores =
                    associado['ProdutosPreco.valorBase'] +
                    totalDep * totalDeMensalidades * valorDesconto;
            valorTotalSomaDependente = somaValores / totalDeMensalidades;
            valorTotal = new Intl.NumberFormat('pt-BR', {
                style: 'currency',
                currency: 'BRL'
            }).format(somaValores);
            break;
        case 'ZPA':
            totalDeMensalidades = 12;
            somaValores = 
            associado['ProdutosPreco.valorBase'] +
                    totalDep * totalDeMensalidades * valorDesconto;
            valorTotalSomaDependente = somaValores / totalDeMensalidades;

            break;
        case 'ZPCA':
            totalDeMensalidades = 11;
            somaValores =
            
                associado['ProdutosPreco.valorBase'] +
                    totalDep * totalDeMensalidades;
            valorTotalSomaDependente = somaValores / totalDeMensalidades;

            break;
        case 'ZPC4':
            totalDeMensalidades = 47;
            somaValores =
            
                associado['ProdutosPreco.valorBase'] +
                    totalDep * totalDeMensalidades;
            valorTotalSomaDependente = somaValores / totalDeMensalidades;

            break;
        default:
            somaValores = associado['ProdutosPreco.valorBase'] + totalDep;

            valorTotalSomaDependente =
                associado['ProdutosPreco.valorBase'] + totalDep;
            break;
        }

        somaValores += valoresAdicionais? valoresAdicionais : 0;
        somaValores -= associado.valorComDesconto? associado.valorComDesconto : 0;

        valorTotal = new Intl.NumberFormat('pt-BR', {
            style: 'currency',
            currency: 'BRL'
        }).format(somaValores);

        return { valorTotal,
            valorTotalSomaDependente };
    }
}
